
export interface RulePrototypeMethod {
    id: string;
    prototype: string;
}

export const OperationPrototypes: RulePrototypeMethod[] =
    [
        {
            id: 'VALUE',
            prototype: 'VALUE(string)',
        },
        {
            id: 'SUM',
            prototype: 'SUM(value1, [value2, ...])',
        },
        {
            id: 'SUBT',
            prototype: '(value1 - value2)',
        },
        {
            id: 'MULTIPLY',
            prototype: '(value1 * value2)',
        },
        {
            id: 'DIVISION',
            prototype: '(value1 / value2)',
        },
        {
            id: 'IF',
            prototype: 'IF(logical_expression, value_if_true, value_if_false)',
        },
        {
            id: 'CONCATENATE',
            prototype: 'CONCATENATE(text1, [text2], ...)',
        },
        {
            id: 'OR',
            prototype: 'OR(logical_expression_1, logical_expression_2)',
        },
        {
            id: 'TRUE',
            prototype: 'TRUE',
        },
    ];

export const EntityTypes: string[] = [
    'documentAttribute',
    'documentComponent',
    'outputAttribute',
    'productReportAttribute',
    'productEmailAttribute'
];

// component based elements of the 
export const PolicyComponentMappings: string[] =
    [
        'QuotationGrid',
        'SyncronizationCandidates',
        'DocumentId',
        'PaymentResults',
        'AttachedFiles',
        'RelatedDocuments',
        'Context',
        'LastUpdate',
        'RelatedDocumentId',
        'CustomerId',
        'QuoteResult',
        'SaleResponse',
        'OperationState',
        'OperationType',
        'State',
        'SubState',
        'OperationKind',
        'CustomerIsInSync',
        'LastVisitedPageId'
    ];

export const TypeOptions: string[]= [
    'DateTime',
    'Double',
    'String',
    'Decimal',
    'Int32',
    'Int64',
    'Boolean'
]; 


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/interfaces/rulePrototype.interface.ts